export enum PortalNameEnum {
  PaymentLink = 'Payment Link',
  AnytimePayment = 'Anytime Payments',
  TokenLink = 'Token Link',
  PaymentIntent = 'AndDoneJS',
  OpenPayment = 'Secure Payment',
  AgentInvATP = 'AMS 360',
}
